import React from "react";
import { StaticImage } from "gatsby-plugin-image";
function Teckstackgame() {
  return (
    <div className="brand_box">
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_1.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_2.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_3.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_4.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_5.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_6.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_7.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
      <div className="brand_img">
        <StaticImage
          src="../../../images/locationgcc/sa/game-sa/icons/icon_8.webp"
          alt="TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={234}
          height={70}
        />
      </div>
    </div>
  );
}

export default Teckstackgame;
